import type { ReactElement } from "react";

import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import scoreCriteriaTrackingService from "app/pages/sales-intelligence/modules/lead-scoring-agent/services/tracking";
import { LeadPriorityScore } from "app/pages/sales-intelligence/modules/lists/types/columns";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import { StyledLeadScoreTooltipFooter } from "./styles";

export interface ILeadScoreTooltipFooterProps {
    domain: string;
    score: LeadPriorityScore;
    onViewSignals?: VoidFunction;
}

const LeadScoreTooltipFooter = ({ score, domain, onViewSignals }: ILeadScoreTooltipFooterProps): ReactElement => {
    const craftAnEmailLink = siNavigator.getCompanyAnalysisSignalsPage(domain);

    const handleManageScore = () => {
        scoreCriteriaTrackingService.trackScoreCriteriaClick("scoring tooltip");
        window.open(siNavigator.getScoreSettingsPageLink(), "_blank");
    };

    const handleViewSignals = () => {
        scoreCriteriaTrackingService.trackViewSignalsClick();
        onViewSignals?.();
    };

    const viewSignalsButton =
        score === LeadPriorityScore.Unlock || score === LeadPriorityScore.NoScore ? null : (
            <a
                href={craftAnEmailLink}
                target="_blank"
            >
                <IconButton
                    type="primary"
                    iconName="link-out"
                    placement="right"
                    onClick={handleViewSignals}
                    dataAutomation="lead-score-tooltip-view-signals"
                >
                    {translate("si.signals.button.view-signals.label")}
                </IconButton>
            </a>
        );

    return (
        <StyledLeadScoreTooltipFooter justifyContent={viewSignalsButton ? "space-between" : "space-around"}>
            <IconButton
                type="flat"
                iconName="settings"
                onClick={handleManageScore}
            >
                {translate("si.lead_score_agent.button.manage_scoring")}
            </IconButton>
            {viewSignalsButton}
        </StyledLeadScoreTooltipFooter>
    );
};

export default LeadScoreTooltipFooter;
